const locationButtonSelector = 'button[data-location-button]';

/**
 * Configures location-based features and map interactions.
 * Sets up geolocation functionality for location buttons and handles map feature filtering based on location.
 *
 * @param {Object} context - The DOM context in which to search for elements
 * @param {Object} drupalSettings - Drupal settings object containing configuration
 * @throws {Error} Will throw an error if geolocation is not supported by the browser
 *
 * @example
 * configureLocationFeatureMap(document, drupalSettings);
 */
export function configureLocationFeatureMap(context, drupalSettings, once) {
  //  Use my location button behaviour
  // 1. Get the location of the user
  // 2. Find the features in the map that are within a certain radius of the location and zoom in to that location
  // 3. Update the view filter button and submit the exposed form
  once('useMyLocation', locationButtonSelector, context).forEach(button => {
    button.addEventListener('click', async event => {
      event.preventDefault(); // Prevent default form submissions

      try {
        if (!('geolocation' in navigator)) {
          throw new Error('Geolocation is not supported by your browser');
        }

        // Get position
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          });
        });

        const { latitude, longitude } = position.coords;
        console.log('Your location', latitude, longitude);

        // Set the map view to the user location
        const lastKey = Object.keys(drupalSettings.leaflet).at(-1);
        const map = drupalSettings.leaflet[lastKey].lMap;
        if (map && latitude && longitude) {
          const userLocation = L.latLng(latitude, longitude);
          map.setView(userLocation, 15.5, {
            animate: true,
            duration: 2 // Duration in seconds
          });
        }
      } catch (error) {
        console.error('Location error:', error);
        alert(
          error.message ||
            'Unable to get your location. Please enter it manually.'
        );
      } finally {
        // Restore button state
        // button.innerHTML = originalContent;
      }
    });
  });
}

// We use this to draw precinct circle
// todo: move this to a separate file
export function initLeafletMapCustomizations(context, drupalSettings, $) {
  // listening to leaflet map init event
  $(context).on('leafletMapInit', function (event, mp, lmap, mapid, markersx) {
    // setting Cicles for precincts
    const map = lmap;

    if (map) {
      // Locking map only to Melbourne
      const maxBounds = [
        [-32.86185, 151.65218],
        [-41.30541, 139.40758]
      ];
      map.setMaxBounds(maxBounds);
      // prevent zooming out of the bounds of Melbourne metro and panning out of the bounds
      map.on('drag', function () {
        map.panInsideBounds(maxBounds);
      });

      const mapViewContainer = context.getElementById('map-view-container');
      const filterLatitude = mapViewContainer.getAttribute(
        'data-location-latitude'
      );
      const filterLongitude = mapViewContainer.getAttribute(
        'data-location-longitude'
      );

      if (
        filterLatitude !== null &&
        filterLongitude !== null &&
        !isNaN(filterLatitude) &&
        !isNaN(filterLongitude) &&
        filterLatitude != '' &&
        filterLongitude != ''
      ) {
        const filterLocation = L.latLng(filterLatitude, filterLongitude);
        console.log(filterLocation);
        map.setView(filterLocation, 16);
      }
    }
  });
}
